import { IHeaderTableForecast } from "@/types/header-forecast-table";

import iconTemp from "@/img/temp-icon.svg";
import iconWindSpeed from "@/img/wind-speed-icon.svg";
import iconWindDirection from "@/img/wind-direction-map-icon.svg";
import iconSignificantWeather from "@/img/icon-weather-responsive/significant-weather-icon.svg";
import iconPrecipitation from "@/img/precipitation-icon.svg";

export const PREVISION_LIST_TABLE_HEADER: IHeaderTableForecast[] = [
	{
		key: "time",
	},
	{
		key: "weather",
		icon: iconSignificantWeather,
	},
	{
		key: "airTemperature",
		icon: iconTemp,
	},
	{
		key: "precipitationAccumulationMm",
		icon: iconPrecipitation,
	},
	{
		key: "windDirection",
		icon: iconWindDirection,
	},
	{
		key: "windSpeedKmh",
		icon: iconWindSpeed,
	},
];
